import React from 'react';
import { IconButtonProps } from 'extended-oxygen-elements';
import { TimerOutlinedIcon } from 'element';
import { IconWrapper } from './components';

export function InProgressIcon(props: IconButtonProps) {
  return (
    <IconWrapper {...props}>
      <TimerOutlinedIcon />
    </IconWrapper>
  );
}
